/* 积分设置 */
<template>
  <div>
    <div class="warpper_top">
      <h1 class="warpper_top_title">积分设置</h1>
      <!-- <a-button type="primary"  @click="submitForm">
                  保存设置
              </a-button> -->
    </div>
    <div class="warpper_con">
      <a-form-model ref="dataInfo" :model="dataInfo" :rules="rules" layout="horizontal">
        <!-- v-bind="layout" -->
        <div class="disFlex flexWrap">
          <a-form-model-item class="" colon label="" prop="addHousingResource">
            <a-checkbox v-if="dataInfo.isAddHousingResource == 'Y'" checked @click="changeFiled('isAddHousingResource')"
              >房源新增</a-checkbox
            >
            <a-checkbox v-else @click="changeFiled('isAddHousingResource')">房源新增</a-checkbox>
            <!-- <a-input-number size="default" v-model="dataInfo.addHousingResource"  :default-value="1"  :min="1"
                        :formatter="value => `${value}分/间`"  :parser="value => value.replace('分/间', '')" /> -->
            <a-input :max-length="6" size="default" v-model="dataInfo.addHousingResource" suffix="分/间" />
          </a-form-model-item>

          <a-form-model-item class="" colon label="" prop="addCustomerResource">
            <a-checkbox
              v-if="dataInfo.isAddCustomerResource == 'Y'"
              checked
              @click="changeFiled('isAddCustomerResource')"
              >客源新增</a-checkbox
            >
            <a-checkbox v-else @click="changeFiled('isAddCustomerResource')">客源新增</a-checkbox>
            <!-- <a-input-number size="default" v-model="dataInfo.addCustomerResource"  :default-value="0"  :min="0"
                        :formatter="value => `${value}分/人`"  :parser="value => value.replace('分/人', '')" /> -->
            <a-input :max-length="6" size="default" v-model="dataInfo.addCustomerResource" suffix="分/人" />
          </a-form-model-item>

          <a-form-model-item class="" colon label="" prop="lookOne">
            <a-checkbox v-if="dataInfo.isLookOne == 'Y'" checked @click="changeFiled('isLookOne')">带看</a-checkbox>
            <a-checkbox v-else @click="changeFiled('isLookOne')">带看</a-checkbox>
            <a-input :max-length="6" size="default" v-model="dataInfo.lookOne" suffix="分/次" />
          </a-form-model-item>

          <a-form-model-item class="" colon label="" prop="lookTwo">
            <a-checkbox v-if="dataInfo.isLookTwo == 'Y'" checked @click="changeFiled('isLookTwo')">二看</a-checkbox>
            <a-checkbox v-else @click="changeFiled('isLookTwo')">二看</a-checkbox>
            <!-- <a-input-number size="default" v-model="dataInfo.lookTwo"  :default-value="1"  :min="1"
                        :formatter="value => `${value}分/人`"  :parser="value => value.replace('分/人', '')" /> -->

            <a-input :max-length="6" size="default" v-model="dataInfo.lookTwo" suffix="分/人" />
          </a-form-model-item>
          <a-form-model-item class="" colon label="" prop="lookThree">
            <a-checkbox v-if="dataInfo.isLookThree == 'Y'" checked @click="changeFiled('isLookThree')">三看</a-checkbox>
            <a-checkbox v-else @click="changeFiled('isLookThree')">三看</a-checkbox>

            <!-- <a-input-number size="default" v-model="dataInfo.lookThree"  :default-value="1"  :min="1"
                        :formatter="value => `${value}分/人`"  :parser="value => value.replace('分/人', '')" /> -->

            <a-input :max-length="6" size="default" v-model="dataInfo.lookThree" suffix="分/人" />
          </a-form-model-item>

          <a-form-model-item class="" colon label="" prop="houseKeys">
            <a-checkbox v-if="dataInfo.isHouseKeys == 'Y'" checked @click="changeFiled('isHouseKeys')">钥匙</a-checkbox>
            <a-checkbox v-else @click="changeFiled('isHouseKeys')">钥匙</a-checkbox>
            <!-- <a-input-number size="default" v-model="dataInfo.houseKeys"  :default-value="1"  :min="1"
                        :formatter="value => `${value}分/次`"  :parser="value => value.replace('分/次', '')" /> -->
            <a-input :max-length="6" size="default" v-model="dataInfo.houseKeys" suffix="分/次" />
          </a-form-model-item>
          <a-form-model-item class="" colon label="" prop="fieldInvestigation">
            <a-checkbox @click="changeFiled('isFieldInvestigation')" v-if="dataInfo.isFieldInvestigation == 'Y'" checked
              >实勘</a-checkbox
            >
            <a-checkbox @click="changeFiled('isFieldInvestigation')" v-else>实勘</a-checkbox>

            <!-- <a-input-number size="default" v-model="dataInfo.fieldInvestigation"  :default-value="1"  :min="1"
                        :formatter="value => `${value}分/次`"  :parser="value => value.replace('分/次', '')" /> -->

            <a-input :max-length="6" size="default" v-model="dataInfo.fieldInvestigation" suffix="分/次" />
          </a-form-model-item>

          <a-form-model-item class="" colon label="" prop="inMore">
            <a-checkbox @click="changeFiled('isInMore')" v-if="dataInfo.isInMore == 'Y'" checked>一带多看</a-checkbox>
            <a-checkbox @click="changeFiled('isInMore')" v-else>一带多看</a-checkbox>

            <a-input :max-length="6" size="default" v-model="dataInfo.inMore" suffix="分/人" />
          </a-form-model-item>

          <a-form-model-item class="" colon label="" prop="doInterview">
            <a-checkbox @click="changeFiled('isDoInterview')" v-if="dataInfo.isDoInterview == 'Y'" checked
              >面访</a-checkbox
            >
            <a-checkbox @click="changeFiled('isDoInterview')" v-else>面访</a-checkbox>

            <a-input :max-length="6" size="default" v-model="dataInfo.doInterview" suffix="分/次" />
          </a-form-model-item>
        </div>
      </a-form-model>
      <div class="disFlex btn_center">
        <a-button type="primary" @click="submitForm"> 保存 </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  integralList,
  getIntegral,
  getIntegralCache,
  addIntegral,
  updateIntegral,
  delIntegral,
} from '@/api/setting/integral'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Integral',
  components: {},
  mixins: [tableMixin],
  data() {
    return {
      total: 0,
      list: [],
      dataObj: {},
      loading: false,
      submitLoading: false,
      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 14 },
      },

      queryParam: {
        pageNum: 1,
        pageSize: 10,
      },
      dataInfo: {
        addCustomerResource: undefined, // 客源新增（分/人）		true
        addHousingResource: undefined, //	房源新增（分/间）		true
        doInterview: undefined, //	面访（分/次）		true
        fieldInvestigation: undefined, //	实勘（分/次）		true
        houseKeys: undefined, //	房源钥匙（分/次）		true
        id: undefined, //	id，新增时不传，修改时必传		true
        inMore: undefined, //	一带多看（分/人）		true
        lookOne: undefined, //	带看（分/次）		true
        lookThree: undefined, //	三看（分/人）		true
        lookTwo: undefined, //	二看（分/人）		true

        isAddCustomerResource: 'Y', //	是否客源新增		true
        isAddHousingResource: 'Y', //	是否房源新增		true
        isDoInterview: 'Y', //	是否面访		true
        isFieldInvestigation: 'Y', //	是否实勘		true
        isHouseKeys: 'Y', //	是否房源钥匙		true
        isInMore: 'Y', //	一带多看		true
        isLookOne: 'Y', //	是否带看		true
        isLookThree: 'Y', //	是否三看		true
        isLookTwo: 'Y', //	是否二看		true
      },
      rules: {
        addCustomerResource: [{ required: true, pattern: /^[0-9]+$/, message: '必填', trigger: 'blur' }],
        addHousingResource: [{ required: true, pattern: /^[0-9]+$/, message: '必填', trigger: 'blur' }],
        doInterview: [{ required: true, pattern: /^[0-9]+$/, message: '必填', trigger: 'blur' }],
        fieldInvestigation: [{ required: true, pattern: /^[0-9]+$/, message: '必填', trigger: 'blur' }],
        houseKeys: [{ required: true, pattern: /^[0-9]+$/, message: '必填', trigger: 'blur' }],
        inMore: [{ required: true, pattern: /^[0-9]+$/, message: '必填', trigger: 'blur' }],
        lookOne: [{ required: true, pattern: /^[0-9]+$/, message: '必填', trigger: 'blur' }],
        lookThree: [{ required: true, pattern: /^[0-9]+$/, message: '必填', trigger: 'blur' }],
        lookTwo: [{ required: true, pattern: /^[0-9]+$/, message: '必填', trigger: 'blur' }],

        isAddCustomerResource: [{ required: true, message: '必选', trigger: 'blur' }],
        isAddHousingResource: [{ required: true, message: '必选', trigger: 'blur' }],
        isDoInterview: [{ required: true, message: '必选', trigger: 'blur' }],
        isFieldInvestigation: [{ required: true, message: '必选', trigger: 'blur' }],
        isHouseKeys: [{ required: true, message: '必选', trigger: 'blur' }],
        isInMore: [{ required: true, message: '必选', trigger: 'blur' }],
        isLookOne: [{ required: true, message: '必选', trigger: 'blur' }],
        isLookThree: [{ required: true, message: '必选', trigger: 'blur' }],
        isLookTwo: [{ required: true, message: '必选', trigger: 'blur' }],
      },
      headers: {
        Authorization: 'Bearer ' + storage.get(ACCESS_TOKEN),
        Accept: 'application/json, text/plain, */*', // multipart/form-data
      },
      columns: [],
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {},
  watch: {},
  methods: {
    /** 查询积分信息列表 */
    getList() {
      this.loading = true
      integralList(this.queryParam).then((response) => {
        if (response.code == 200) {
          const resData = response.data
          this.total = resData.total
          if (this.total > 0) {
            this.list = resData.records
            this.dataObj = resData.records[0]
            this.dataInfo = this.dataObj
          }
        }
        this.loading = false
      })
    },
    handleProvinceChange(value) {
      this.cities = cityData[value]
      this.secondCity = cityData[value][0]
    },
    submitForm() {
      this.$refs.dataInfo.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          if (this.dataInfo.id !== undefined) {
            updateIntegral(this.dataInfo)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                // 获取详情信息
                this.getList()
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            addIntegral(this.dataInfo)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                // 获取详情信息
                this.getList()
              })
              .finally(() => {
                this.submitLoading = false
              })
          }
        } else {
          return false
        }
      })
    },
    getDetail() {
      const IntegralId = this.dataInfo.id
      getIntegral(IntegralId).then((response) => {
        this.dataInfo = response.data
      })
    },
    changeFiled(filedname) {
      const val = this.dataInfo[filedname]
      this.dataInfo[filedname] = val == 'Y' ? 'N' : 'Y'
    },
  },
}
</script>

<style lang="less" scoped>
@titleFontSize: 20px;
@titleColor: #222;
@bodyFont: 14px;
@bodyColor: #666;
@tagFont: 12px;
@tagColor: #ddd;
.flexWrap {
  flex-wrap: wrap;
}
.warpper_top {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.warpper_top_title {
  font-size: @titleFontSize;
  font-weight: bold;
  color: @titleColor;
}

.ant-form-item {
  width: 18%;
  margin-right: 2.5%;
}
.ant-form-item:nth-child(5n + 5) {
  margin-right: 0;
}
.ant-form-item-children {
  display: flex;
  flex-direction: column;
}
.ant-form-item label {
  display: block;
}
.warpper_top,
.warpper_con {
  background: #fff;
  padding: 20px;
}
.warpper_con {
  margin-top: 10px;
}

.line {
  border-bottom: 1px solid #f2f2f2;
  margin-bottom: 20px;
}
.btn_center {
  height: 100px;
  justify-content: center;
  align-items: center;
}
</style>
